export default __webpack_public_path__ + "3315950cbe0aec773d6e9fdee7addfd4.png";